import { Me, MeService } from '../../vendor/authz-api';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AuthzNgRxAwareService } from './authz.service';

export class AuthzRestService extends AuthzNgRxAwareService {

  private me?: BehaviorSubject<Me>;
  constructor(private meService: MeService) {
    super();
  }

  private getMe(): Observable<Me> {
    if (this.me) {
      return this.me.asObservable();
    } else {
      return this.meService.me().pipe(
        tap((me: Me) => {
          me = {
            ...me,
            traitements: me.traitements?.map(t => t.toUpperCase()),
          };
        this.me = new BehaviorSubject(me);
      }));
    }
  }

  lireListeTraitements(): Observable<string[]> {
    return this.getMe().pipe(
      map((me: Me) => me.traitements.map(t => t.toUpperCase())),
    );
  }

  lireListePerimetres(): Observable<string[]> {
    return this.getMe().pipe(
      map((me: Me) => me.perimetres.map(p => p.toUpperCase())),
    );
  }

  hasTraitement(traitement: string): Observable<boolean> {
    const traitementToUpperCase = traitement.toUpperCase();
    return this.lireListeTraitements().pipe(
      map((traitements: string[]) => traitements.some((t: string) => t === traitementToUpperCase))
    );
  }

  lireListeModules(): Observable<string[]> {
    return this.getMe().pipe(
      map((me: Me) => me.modules)
    );
  }

  hasAccessToModule(moduleName: string): Observable<boolean> {
    return this.lireListeModules().pipe(
      map((modules: string[]) => modules.some(m => m === moduleName))
    );
  }

  hasAccessToAnyModule(moduleNames: string[]): Observable<boolean> {
    return this.lireListeModules().pipe(
      map((modules: string[]) => moduleNames.some(requiredModule => modules.some(m => m === requiredModule)))
    )
  }

}

